import { Box, styled } from '@mui/material';

import { TrialBadgeIcon as TrialBadgeIcon } from '#shared';

const Root = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  verticalAlign: 'middle',
}));

type Props = {
  /** Size of the badge  width x height */
  size?: number | string;
};

export const TrialBadge = ({ size = 10 }: Props) => (
  <Root>
    <TrialBadgeIcon width={size} height={size} />
  </Root>
);
